<template>
    <div class="border border-solid border-grey-light rounded relative overflow-hidden" id="check-metering-app">
        <vs-sidebar class="items-no-padding" parent="#check-metering-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <VuePerfectScrollbar class="check-metering-sidebar-scroll-area pt-2" :settings="settings">
                <div
                        class="pl-6 pr-2 pt-4 cursor-pointer"
                        :class="{'text-primary': currentHouse === house.id}"
                        v-for="house in houses"
                        :key="`house-${house.id}`"
                        @click="currentHouse = house.id"
                >
                    {{house.address}}
                </div>
            </VuePerfectScrollbar>
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="check-metering-fixed-height border border-r-0 border-b-0 border-t-0 border-solid border-grey-light app-fixed-height" style="background: #fff">
            <div class="flex items-center app-search-container border border-l-0 border-r-0 border-t-0 border-solid border-grey-light ">
                <!-- TOGGLE SIDEBAR BUTTON -->
                <feather-icon class="md:inline-flex lg:hidden ml-8 mr-4 my-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"></feather-icon>
                <h4 class="p-4" v-if="currentApart">Квартира {{currentApart.number}}</h4>
            </div>

            <div class="check-metering-content-area" v-if="currentHouse">
                <VuePerfectScrollbar class="flex-1" :settings="settings" ref="tariffPs">
                    <div class="px-4 mt-4" v-if="!meteringDevicesValues.length">
                        <h4 class="text-center">Приборов нет</h4>
                    </div>
                    <div class="px-4 mt-4" v-else>
                        <div v-for="deviceValue in meteringDevicesValues" :key="`device_value-${deviceValue.factory_number}`">
                            <vs-input :label="`${deviceValue.name} (${deviceValue.factory_number})`" v-model.number.trim="deviceValue.value" class="mb-4 w-full"></vs-input>
                        </div>
                    </div>
                </VuePerfectScrollbar>

                <div class="px-4">
                    <div class="vx-row">
                        <div class="vx-col w-full" v-if="currentApartIndex < this.aparts.length">
                            <vs-button type="filled" color="danger" class="mb-2 w-full" @click="currentApartIndex++">Пропустить</vs-button>
                        </div>
                        <div class="vx-col w-full" v-if="meteringDevicesValues.length">
                            <vs-button type="filled" color="success" class="mb-2 w-full" @click="saveDeviceValue">Отправить</vs-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        name: "CheckMetering",
        components: {
            VuePerfectScrollbar
        },
        data(){
            return {
                clickNotClose: true,
                isSidebarActive: true,
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: 0.30,
                },
                houses: [],
                aparts: [],
                currentHouse: null,
                currentApartIndex: null,
                meteringDevices: [],
                meteringDevicesValues: [],
                deviceTypes: [],
            }
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth;
            },
            management_companies_id(){
                return this.$store.getters['appUser/management_companies_id'];
            },
            currentApart(){
                return this.aparts[this.currentApartIndex];
            }
        },
        methods: {
            toggleSidebar(value = false) {
                if (!value && this.clickNotClose) return;
                this.isSidebarActive = value;
            },
            setSidebarWidth() {
                if (this.windowWidth < 992) {
                    this.isSidebarActive = this.clickNotClose = false;
                } else {
                    this.isSidebarActive = this.clickNotClose = true;
                }
            },
            async getHouses(){
                let {data} = await this.$http.get('houses?mcs=' + this.management_companies_id);
                this.houses = data;
                this.currentHouse = data[0].id;
            },
            async getAparts(){
                let {data} = await this.$http.get(`aparts?buildings_id=${this.currentHouse}`);
                await this.getMetering(data[0].account_number);
                this.currentApartIndex = 0;
                this.aparts = data;
            },
            async getMetering(account_number){
                return new Promise(async resolve => {
                    let {data} = await this.$http.get('devices?account_number='+account_number);
                    this.meteringDevices = data;
                    resolve(data);
                });
            },
            async saveDeviceValue(){
                this.meteringDevicesValues.forEach(device => {
                    if(typeof device.value === 'number'){
                        device.date = Date.now();
                    }
                });
                this.currentApartIndex++;
            },
            getDeviceTypeById(id){
                let deviceType = this.deviceTypes.find(deviceType => deviceType.id === id);
                return deviceType ? deviceType.name : null;
            },
            getDeviceTypes(){
                return new Promise(async resolve => {
                    let {data} = await this.$http.get('devices_type');
                    this.deviceTypes = data;
                    resolve(data);
                })
            }
        },
        watch: {
            windowWidth() {
                this.setSidebarWidth();
            },
            currentHouse(){
                this.getAparts();
            },
            async currentApartIndex(){
                await this.getMetering(this.currentApart.account_number);
                this.meteringDevicesValues = [];
                if(this.meteringDevices.length > 0){
                    this.meteringDevices.forEach(device => {
                        if(device.factory_number && this.getDeviceTypeById(device.type)){
                            this.meteringDevicesValues.push({
                                name: this.getDeviceTypeById(device.type),
                                factory_number: device.factory_number,
                                value: null,
                                account_number: device.account_number,
                            });
                        }
                    });
                }
            }
        },
        async mounted(){
            await this.getDeviceTypes();
            this.getHouses();
        },
        created() {
            this.setSidebarWidth();
        }
    }
</script>

<style lang="scss">

    #check-metering-app {
        .vs-sidebar--background {
            position: absolute;
        }

        .check-metering-content-scroll-area{
            position: relative;
            margin: auto;
            width: 100%;
            height: calc(100% - 145px);
        }
    }

    .check-metering-content-area{
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
    }

    .check-metering-fixed-height{
        height: calc(100vh - 11.2rem);

        @media (min-width: 450px) {
            height: calc(100vh - 14.1rem);
        }
    }



</style>